import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GlassNav from "@/components/GlassNav";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Auth({ mode = "login" }) {
  const isSignup = mode === "signup";
  const { login, signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isSignup) await signup(name, email, password);
      else await login(email, password);
      toast.success(isSignup ? "Welcome!" : "Signed in");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative">
      <GlassNav />
      <div className="pt-28 pb-24 px-4 max-w-md mx-auto">
        <div className="glass p-8 gloss-highlight fade-in">
          <div className="font-serif text-4xl mb-2">{isSignup ? "Create account" : "Welcome back"}</div>
          <p className="text-neutral-600 text-sm mb-6">{isSignup ? "Start your wedding memory page." : "Sign in to your dashboard."}</p>
          <form onSubmit={submit} className="space-y-3">
            {isSignup && (
              <input required value={name} onChange={(e)=>setName(e.target.value)} placeholder="Your name"
                     className="glass-input w-full rounded-full px-5 py-3 text-sm" data-testid="auth-name" />
            )}
            <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email"
                   className="glass-input w-full rounded-full px-5 py-3 text-sm" data-testid="auth-email" />
            <input required type="password" minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Password"
                   className="glass-input w-full rounded-full px-5 py-3 text-sm" data-testid="auth-password" />
            <button disabled={loading} className="btn-accent rounded-full w-full py-3 text-sm mt-2" data-testid="auth-submit">
              {loading ? "..." : (isSignup ? "Create account" : "Sign in")}
            </button>
          </form>
          <div className="mt-5 text-sm text-neutral-600 text-center">
            {isSignup ? (
              <>Already have an account? <Link to="/login" className="underline" data-testid="link-login">Sign in</Link></>
            ) : (
              <>New here? <Link to="/signup" className="underline" data-testid="link-signup">Create an account</Link></>
            )}
          </div>
          {!isSignup && (
            <div className="mt-4 text-xs text-neutral-500 text-center">
              Try demo: <span className="font-medium">sarah@demo.com</span> / <span className="font-medium">demo1234</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
